<template>
  <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
    <section :class="this.name">
      <div class="bg"></div>
      <div class="content">
        <detail v-show="activeLayer == 'support1'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/support/support1-title.png`" alt=""></h1>
          <p class="detail__sub-title"><img :src="`${$staticUrl}img/detail/support/support1-sub-title.png`" alt=""></p>

          <slide ref="support1"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.support1.list"
                 :width="documentSize.width"
                 :height="layerData.support1.height"
                 :noPagination="true">
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/support/support1-con-1.png`" alt="" slot="slide0"/>
            <!--<div class="promokit-slide__img"  slot="slide1">-->
              <!--<a href="javascript:alert('3/27일 공개됩니다.')"><img  :src="`${this.$staticUrl}img/detail/support/support1-con-2.png`" alt="" /></a>-->
            <!--</div>-->

            <div id="support-video-1" class="promokit-slide__video youtube-player" style="width: 1000px;height: 563px;" slot="slide1"></div>
          </slide>

          <div class="slide-dot-area">
            <button :class="['slide-dot-area__button', layerData.support1.index == 0 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(0)">1번 슬라이드
            </button>

            <button :class="['slide-dot-area__button', layerData.support1.index == 1 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(1)">2번 슬라이드
            </button>
          </div>
        </detail>

        <detail v-show="activeLayer == 'support2'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/support/support2-title.png`" alt=""></h1>
          <p class="detail__sub-title"><img :src="`${$staticUrl}img/detail/support/support2-sub-title.png`" alt=""></p>

          <slide ref="support2"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.support2.list"
                 :width="documentSize.width"
                 :height="layerData.support2.height"
                 :noPagination="true">

            <div slot="slide0" class="download">
              <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/support/support2-con-1.png`" alt=""/>
              <a class="download__google" href="https://play.google.com/store/apps/details?id=com.ncsoft.mplayer" target="_blank">구글플레이에서 예티 다운로드</a>
              <a  class="download__apple" href="https://itunes.apple.com/kr/app/id1435848675" target="_blank">앱스토어에서 예티 다운로드</a>
            </div>
            <!--<div class="promokit-slide__img"  slot="slide1">-->
              <!--<a href="javascript:alert('3/27일 공개됩니다.')"><img  :src="`${this.$staticUrl}img/detail/support/support2-con-2.png`" alt="" /></a>-->
            <!--</div>-->

            <div id="support-video-2" class="promokit-slide__video youtube-player" style="width: 1000px;height: 563px;" slot="slide1"></div>
          </slide>

          <div class="slide-dot-area">
            <button :class="['slide-dot-area__button', layerData.support2.index == 0 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(0)">1번 슬라이드
            </button>

            <button :class="['slide-dot-area__button', layerData.support2.index == 1 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(1)">2번 슬라이드
            </button>
          </div>
        </detail>

        <detail v-show="activeLayer == 'support3'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/support/support3-title.png`" alt=""></h1>
          <p class="detail__sub-title"><img :src="`${$staticUrl}img/detail/support/support3-sub-title.png`" alt=""></p>

          <slide ref="support3"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.support3.list"
                 :width="documentSize.width"
                 :height="layerData.support3.height"
                 :noPagination="true">
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/support/support3-con-1.png`" alt="" slot="slide0"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/support/support3-con-2.png`" alt="" slot="slide1"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/support/support3-con-3.png`" alt="" slot="slide2"/>`,
            <div id="support-video-3" class="promokit-slide__video player" style="width: 1000px;height: 563px;" slot="slide3"></div>
          </slide>

          <div class="slide-dot-area">
            <button :class="['slide-dot-area__button', layerData.support3.index == 0 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(0)">1번 슬라이드
            </button>
            <button :class="['slide-dot-area__button', layerData.support3.index == 1 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(1)">2번 슬라이드
            </button>
            <button :class="['slide-dot-area__button', layerData.support3.index == 2 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(2)">3번 슬라이드
            </button>
            <button :class="['slide-dot-area__button', layerData.support3.index == 3 && 'slide-dot-area__button--active']"
                    @click="handleClickTo(3)">4번 슬라이드
            </button>
          </div>
        </detail>
      </div>
    </section>
  </transition>
</template>
<script>
  import BasePage from "./mixins/basePage.js";
  import YoutubePlayer from "promokit-youtubeplayer";
  import VideoPlayer from "promokit-videoplayer";

  export default {
    name: "support",
    mixins: [BasePage],
    data() {
      return {
        name: "support",
        contentData: [
          //{type: "bg", source: this.$staticUrl + "img/bg_2.jpg", objName: "bg"},
          {type:'bg', source:'https://vod.plaync.com/lineage/remaster0320/0320_remaster_bg2.mp4', objName:'bgmovie'},
          {type: "chr", source: this.$staticUrl + "img/obj_2.png", objName: "chr_1", x: 125, y: 165},
          {type: "txt", source: this.$staticUrl + "img/txt_2_tit.png", objName: "obj_tit", x: 969, y: 360},
          {type: "txt", source: this.$staticUrl + "img/txt_2_stit.png", objName: "obj_stit", x: 950, y: 396},
          {type: "txt", source: this.$staticUrl + "img/txt_2_txt.png", objName: "obj_txt", x: 977, y: 592},
          {type: "btn", source: this.$staticUrl + "img/btn_2_1.png", objName: "support1", x: 974, y: 680},
          {type: "btn", source: this.$staticUrl + "img/btn_2_2.png", objName: "support2", x: 1195, y: 680},
          {type: "btn", source: this.$staticUrl + "img/btn_2_3.png", objName: "support3", x: 1428, y: 680},
        ],
        layerData: {
          support1: {
            list: 2,
            index: 0,
            height: 628,
          },
          support2: {
            list: 2,
            index: 0,
            height: 619,
          },
          support3: {
              list: 4,
              index: 0,
              height: 565,
          },
        },
          videoSupport3 : null
      };
    },
     computed:{
         support3Index(){
            return this.layerData.support3.index;
         }
     } ,


      watch:{
          support3Index(x){
            if(x == 3)this.videoSupport3.play();
          }
      },
    methods: {
      canvasSet() {
        this.baseCavasSet(this.contentData);
      },
      enter(el, done) {
        this.baseEnter();
        this.canvasSet();
        //this.canvas.start();
        this.baseEnterMotion(el, done, this.contentData);
        this.enterMotion.play();
      },
      leave(el, done) {
        if (this.enterMotion) this.enterMotion.pause();
        this.baseLeaveMotion(el, done);
      },
    },
    mounted() {
      let videoSupport1 = new YoutubePlayer({
        el: "#support-video-1",
        videoId: "rkM-QiekJYc",
      });

      let videoSupport2 = new YoutubePlayer({
        el: "#support-video-2",
        videoId: "-pac6UA9AIA",
      });

        this.videoSupport3 = new VideoPlayer({
            el: "#support-video-3",
            url: "http://vodfile.ncsoft.co.kr/ncvod/plaync/Lineage/0320_remaster_pss1.mp4",
            mute: true,
            controls: false,
            loop: true,
            autoplay: false
        });

      videoSupport1.on("play", () => {
        window.nowPlayingVideo = videoSupport1;
      });

      videoSupport2.on("play", () => {
        window.nowPlayingVideo = videoSupport2;
      });

        this.videoSupport3.on("play", () => {
            window.nowPlayingVideo = this.videoSupport3;
       });
    },
  };
</script>

<style lang="scss">
  .download{
    position: relative;

    &__google{
      position: absolute;
      bottom: 1px;
      left: 50%;
      margin-left: 200px;
      width: 140px;
      height: 50px;
      @include hide-text;
    }

    &__apple{
      position: absolute;
      bottom: 1px;
      left: 50%;
      margin-left: 358px;
      width: 130px;
      height: 50px;
      @include hide-text;
    }
  }
</style>